export default __webpack_public_path__ + "static/media/landing-title.215e33aa.svg";